<div id="right-hand-menu-icon" class="close">
    <a class="close-icon" (click)="logout()">
    &times;
    </a>
</div>

<div class="recovery-tool-header">
    <img  src="assets/images/logo.png"/>
</div>

<app-modal
        [show]="showModal"
        [customClass]="'custom_modal_class'"
        [closeCallback]="toggleModal"
>
    <h5>Lesson Details</h5>
    <hr class="k12-lss-modal-line">
    <div class="k12-lss-modal-table">
        <table id="k12-lesson-data-modal-table">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>ID</th>
                    <th>Details</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let datum of successfulLessons">

                    <td class="k12-table-left-align">{{datum.displayName}}</td>
                    <td class="k12-table-left-align k12-lss-modal-text" >{{datum.lessonNodeId}} </td>
                    <td class="k12-table-left-align">{{datum.detail}}</td>

                </tr>
                <tr *ngFor="let datum of failedLessons">
                    <td class="k12-table-left-align">{{datum.displayName}}</td>
                    <td class="k12-table-left-align k12-lss-modal-text" >{{datum.lessonNodeId}} </td>
                    <td class="k12-table-left-align">{{datum.detail}}</td>
                </tr>
            </tbody>

        </table>
    </div>
</app-modal>

<div>
    <div class="reload-button-div">
        <button class="btn btn-primary reloadButton" (click)="reloadOriginalTable()">Reload Table Data</button>
    </div>
    </div>
<div> 
    <div class="date-picker">
        <app-datepicker (datePickerOnValueChange)="dpValueChange($event)"></app-datepicker>
    </div>
</div>


<div class="recovery-tool-selection-row">
<div class="row">
    <div *ngIf="s2SchoolData; else loading_school_content" class="col-sm-4">
        <ng-select2 class="k12-selectBox"
            [data]="s2SchoolData"
            [placeholder]="'Please select a school...'"
            [width]="400"
            [allowClear]=true        
            (valueChanged)="onSchoolSelected(s2SchoolData[$event] != null ? s2SchoolData[$event].searchId : null)">
            <option value=""></option>
        </ng-select2>
    </div>
    <div *ngIf="s2ClassroomData; else loading_classroom_content" class="col-sm-4">
        <ng-select2 class="k12-selectBox"
            [data]="s2ClassroomData"
            [placeholder]="'Please select a classroom...'"
            
            [width]="400"
            [allowClear]=true        
            (valueChanged)="onClassroomSelected(s2ClassroomData[$event] != null ? s2ClassroomData[$event].searchId : null)">
            <option value=""></option>
        </ng-select2>
    </div>
    <div *ngIf="s2StudentData; else loading_student_content" class="col-sm-4">
        <ng-select2 class="k12-selectBox"
            [data]="s2StudentData"
            [placeholder]="'Please select a student...'"
            [width]="400"
            [allowClear]=true        
            (valueChanged)="onStudentSelected(s2StudentData[$event] != null ? s2StudentData[$event].searchId : null)">
            <option value=""></option>
        </ng-select2>
    </div>

    <ng-template #loading_school_content>
        <div class="col-sm-4">
            <div class="spinner-border spinner-border-sm text-info" role="status">
                <span class="sr-only">Loading...</span>               
            </div>
            Retrieving School List...
        </div>
    </ng-template>
    <ng-template #loading_classroom_content>         
        <div class="col-sm-4">
            <div class="spinner-border spinner-border-sm text-info" role="status">
                <span class="sr-only">Loading...</span>               
            </div>
            Retrieving Classroom List...               
        </div>
    </ng-template>    
    <ng-template #loading_student_content>
        <div class="col-sm-4">
            <div class="spinner-border spinner-border-sm text-info" role="status">
                <span class="sr-only">Loading...</span>               
            </div>
            Retrieving Student List...            
        </div>
    </ng-template>

    </div>
</div>

<div *ngIf='displayTable' class="recovery-tool-dataTable" >
    <table datatable [dtOptions]="dtOptions" id="datatable" class="hover row-border dt-right recovery-tool-table-color"></table>
</div>

<notifier-container></notifier-container>